import { render, staticRenderFns } from "./VaccinationsBase.vue?vue&type=template&id=292a8294"
import script from "./VaccinationsBase.vue?vue&type=script&lang=js"
export * from "./VaccinationsBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports